export const L10N = {
  LABEL_SECURE_PAGE: { id: 'core.label.secure_page' },
};
